// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { createBrandMuiTheme } from "./config/brandTheme";
import SignupPage from "./components/SignupPage";
import WhaleLoadingScreen from "./components/WhaleLoadingScreen";
import ItemSharePage from "./components/ItemSharePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import ReturnPolicy from "./components/ReturnPolicy";
import CancellationPolicy from "./components/CancellationPolicy";
import ContactUs from "./components/ContactUs";

const theme = createBrandMuiTheme();

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if this is the first time loading in this session
    const hasLoadedBefore = sessionStorage.getItem("hasLoadedBefore");

    if (!hasLoadedBefore) {
      // First time loading - show full whale animation
      sessionStorage.setItem("hasLoadedBefore", "true");
      setIsLoading(true);
      // Let WhaleLoadingScreen handle the timing with onLoadingComplete
    } else {
      // Already loaded before in this session - show shorter animation
      setIsLoading(true);
      // Show a shorter version for subsequent loads
      setTimeout(() => {
        setIsLoading(false);
      }, 1500); // Shorter duration for return visits
    }
  }, []);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          {isLoading && (
            <WhaleLoadingScreen onLoadingComplete={handleLoadingComplete} />
          )}

          {!isLoading && (
            <Routes>
              {/* Main app route */}
              <Route path="/" element={<SignupPage />} />

              {/* Item share route */}
              <Route path="/item/:itemId" element={<ItemSharePage />} />

              {/* Policy pages */}
              <Route path="/privacy-policy" element={<PrivacyPolicy onBack={() => window.history.back()} />} />
              <Route path="/terms-of-service" element={<TermsOfService onBack={() => window.history.back()} />} />
              <Route path="/return-policy" element={<ReturnPolicy onBack={() => window.history.back()} />} />
              <Route path="/cancellation-policy" element={<CancellationPolicy onBack={() => window.history.back()} />} />
              <Route path="/contact-us" element={<ContactUs onBack={() => window.history.back()} />} />

              {/* Catch all other routes and redirect to home */}
              <Route path="*" element={<SignupPage />} />
            </Routes>
          )}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
